module.exports = __webpack_public_path__ + "static/media/fotoproduct.0f19a5e4.png";